<div id="navigation-carousel-container">
	<ngu-carousel #carousel [inputs]="carouselOne" (initData)="initDataFn($event)" [dataSource]="navWidgets">
		<ngu-tile
			NguCarouselItem
			*nguCarouselDef="let navWidget; let index = index"
			class="{{ navWidget.widgetPath }}-product-card"
			[ngClass]="{
				'primary-color-border': navWidget.widgetPath === currentPath,
				'not-selected': navWidget.widgetPath !== currentPath && navWidget.widgetPath !== 'overview',
				selected: navWidget.widgets && navWidget.widgetPath === currentPath && navWidget.widgetPath !== 'overview'
			}"
		>
			<div class="nav-item-container">
				<div
					class="nav-left-section"
					[ngStyle]="{
						width:
							navWidget.widgetPath !== 'overview' && navWidget.widgetPath === currentPath && navWidget.widgets
								? '48%'
								: '100%'
					}"
				>
					<div
						class="printable_button_r4"
						[ngClass]="{ printable_button_disabled: navItemsStatus[navWidget.widgetPath]?.isDisabled }"
						*ngIf="version == 'r4' && navWidget.widgetPath !== 'overview' && navWidget.widgetPath === currentPath"
					>
						<app-printable-report-r1></app-printable-report-r1>
					</div>
					<div
						class="printable_button_r4 overview-printable-button"
						[ngClass]="{ printable_button_disabled: navItemsStatus[navWidget.widgetPath]?.isDisabled }"
						*ngIf="version == 'r4' && navWidget.widgetPath == 'overview'"
					>
						<app-printable-report-r1 overviewprintablereport="overview"></app-printable-report-r1>
					</div>
					<app-nav-link
						[sectiontitle]="navWidget.widgetTitle"
						[sectionpath]="navWidget.widgetPath"
						[key]="navWidget.query.key"
						[downloadconfig]="navWidget.downloadConfig"
						[sectionclass]="navWidget.widgetClass"
						[downloadcsvcolumns]="navWidget.downloadCSVColumns"
					></app-nav-link>
					<div
						class="nav-stats-container stats-section"
						*ngIf="
							overviewStatsData &&
							navWidget.widgetPath !== 'overview' &&
							overviewStatsData &&
							navWidget.widgetPath !== 'ctv' &&
							navWidget.widgetPath !== 'radio' &&
							navWidget.widgetPath !== 'email'
						"
						(click)="navigateToPage(navWidget, index)"
					>
						<div class="stat-container">
							<div class="stat-value" *ngIf="overviewStatsData[navWidget.widgetPath]?.impressions">
								{{ overviewStatsData[navWidget.widgetPath]?.impressions | formatNumber }}
							</div>
							<div class="stat-value" *ngIf="!overviewStatsData[navWidget.widgetPath]?.impressions">--</div>
							<div class="stat-text">Impressions</div>
						</div>
						<div class="stat-container">
							<div class="stat-value" *ngIf="overviewStatsData[navWidget.widgetPath]?.clicks">
								{{ overviewStatsData[navWidget.widgetPath]?.clicks | formatNumber }}
							</div>
							<div class="stat-value" *ngIf="!overviewStatsData[navWidget.widgetPath]?.clicks">--</div>
							<div class="stat-text">Clicks</div>
						</div>
						<div class="stat-container">
							<div class="stat-value" *ngIf="overviewStatsData[navWidget.widgetPath]?.ctr">
								{{ overviewStatsData[navWidget.widgetPath]?.ctr | number : '1.2-2' }}%
							</div>
							<div class="stat-value" *ngIf="!overviewStatsData[navWidget.widgetPath]?.ctr">--</div>
							<div class="stat-text">CTR</div>
						</div>
						<!-- <div class="stat-container">
              <div class="stat-value">{{overviewStatsData[navWidget.widgetPath]?.ctr}}%</div>
              <div class="stat-text">CTR</div>
            </div> -->
					</div>
					<div
						class="stats-section"
						*ngIf="overviewStatsData && navWidget.widgetPath === 'overview'"
						(click)="navigateToPage(navWidget, index)"
					>
						<div class="stat-container">
							<div class="stat-value" *ngIf="getTotalByColumn('impressions')">
								{{ getTotalByColumn('impressions') | number }}
							</div>
							<div class="stat-value" *ngIf="!getTotalByColumn('impressions')">--</div>
							<div class="stat-text">Impressions</div>
						</div>
						<div class="stat-container">
							<div class="stat-value" *ngIf="getTotalByColumn('clicks')">{{ getTotalByColumn('clicks') | number }}</div>
							<div class="stat-value" *ngIf="!getTotalByColumn('clicks')">--</div>
							<div class="stat-text">Clicks</div>
						</div>
						<div class="stat-container">
							<div class="stat-value" *ngIf="getTotalCTR()">{{ getTotalCTR() | percent : '1.2-2' }}</div>
							<div class="stat-value" *ngIf="!getTotalCTR()">--</div>
							<div class="stat-text">CTR</div>
						</div>
					</div>
					<div
						class="stats-section"
						*ngIf="overviewStatsData && navWidget.widgetPath === 'ctv'"
						(click)="navigateToPage(navWidget, index)"
					>
						<div class="stat-container ctv-imp-stat-container">
							<div class="stat-value" *ngIf="overviewStatsData['ctv']?.impressions">
								{{ overviewStatsData['ctv']?.impressions | number }}
							</div>
							<div class="stat-value" *ngIf="!overviewStatsData['ctv']?.impressions">--</div>
							<div class="stat-text">Impressions</div>
						</div>
						<div class="stat-container ctv-comp-stat-container">
							<div class="stat-value" *ngIf="overviewStatsData['ctv']?.completions">
								{{ overviewStatsData['ctv']?.completions | number }}
							</div>
							<div class="stat-value" *ngIf="!overviewStatsData['ctv']?.completions">--</div>
							<div class="stat-text">Completions</div>
						</div>
						<div class="stat-container ctv-cmpr-stat-container">
							<div class="stat-value" *ngIf="overviewStatsData['ctv']?.completions_rate">
								{{ overviewStatsData['ctv']?.completions_rate | number : '1.2-2' }}%
							</div>
							<div class="stat-value" *ngIf="!overviewStatsData['ctv']?.completions_rate">--</div>
							<div class="stat-text">VCR</div>
						</div>
					</div>
					<div
						class="stats-section"
						*ngIf="overviewStatsData && navWidget.widgetPath === 'radio'"
						(click)="navigateToPage(navWidget, index)"
					>
						<div class="stat-container ctv-imp-stat-container">
							<div class="stat-value" *ngIf="overviewStatsData['radio']?.impressions">
								{{ overviewStatsData['radio']?.impressions | number }}
							</div>
							<div class="stat-value" *ngIf="!overviewStatsData['radio']?.impressions">--</div>
							<div class="stat-text">Impressions</div>
						</div>
						<div class="stat-container ctv-comp-stat-container">
							<div class="stat-value" *ngIf="overviewStatsData['radio']?.completions">
								{{ overviewStatsData['radio']?.completions | number }}
							</div>
							<div class="stat-value" *ngIf="!overviewStatsData['radio']?.completions">--</div>
							<div class="stat-text">Completions</div>
						</div>
						<div class="stat-container ctv-cmpr-stat-container" tooltip="Audio Completion Rate">
							<div class="stat-value" *ngIf="overviewStatsData['radio']?.completions_rate">
								{{ overviewStatsData['radio']?.completions_rate | number : '1.2-2' }}%
							</div>
							<div class="stat-value" *ngIf="!overviewStatsData['radio']?.completions_rate">--</div>
							<div class="stat-text">ACR</div>
						</div>
					</div>
					<div
						class="stats-section"
						*ngIf="overviewStatsData && navWidget.widgetPath === 'email'"
						(click)="navigateToPage(navWidget, index)"
					>
						<div class="stat-container ctv-imp-stat-container">
							<div class="stat-value" *ngIf="overviewStatsData['email']?.audience">
								{{ overviewStatsData['email']?.audience | number }}
							</div>
							<div class="stat-value" *ngIf="!overviewStatsData['email']?.audience">--</div>
							<div class="stat-text">Sends</div>
						</div>
						<div class="stat-container ctv-imp-stat-container">
							<div class="stat-value" *ngIf="overviewStatsData['email']?.opens">
								{{ overviewStatsData['email']?.opens | number }}
							</div>
							<div class="stat-value" *ngIf="!overviewStatsData['email']?.opens">--</div>
							<div class="stat-text">Opens</div>
						</div>
						<div class="stat-container ctv-imp-stat-container">
							<div class="stat-value" *ngIf="overviewStatsData['email']?.clicks">
								{{ overviewStatsData['email']?.clicks | number }}
							</div>
							<div class="stat-value" *ngIf="!overviewStatsData['email']?.clicks">--</div>
							<div class="stat-text">Clicks</div>
						</div>
					</div>
				</div>
				<div
					class="nav-right-section"
					*ngIf="navWidget.widgetPath === currentPath && navWidget.widgetPath !== 'overview'"
					[ngClass]="currentPath"
				>
					<ul>
						<li
							*ngFor="let widget of navWidget.widgets; let index = index"
							(click)="navigateToWidget(index, widget.widget)"
							class="nav-right-sec-label {{ widget.widget }}"
							[ngClass]="{ 'selected primary-color': index === activeIndex }"
						>
							{{ widget.widget }}
						</li>
					</ul>
				</div>
				<div
					class="navigation-disabled-container"
					(click)="navigateToPage(navWidget, index)"
					*ngIf="navWidget.widgetPath !== 'overview' && navItemsStatus[navWidget.widgetPath]?.isDisabled"
				></div>
			</div>
		</ngu-tile>
		<span NguCarouselPrev class="leftRs">
			<i class="fa fa-angle-left" aria-hidden="true"></i>
		</span>
		<span NguCarouselNext class="rightRs">
			<i class="fa fa-angle-right" aria-hidden="true"></i>
		</span>
	</ngu-carousel>
</div>
